module.exports = __webpack_public_path__ + "static/media/icon-price-med.a2bc5062.svg";